export const MODULE_NAME = "FLIGHT-PROVIDER"

// -------------- State -------------- //

const defaultState = () => ({
  uuidDocument: null,
  email: null,
  name: null,
  cpf: null,
  birthdate: null,
  keySigner: null,
})

const state = defaultState()

// -------------- Mutations -------------- //
const MUTATIONS_TYPES = {
  SET_UUID_DOCUMENT: 'SET_UUID_DOCUMENT',
  SET_EMAIL: 'SET_EMAIL',
  SET_NAME: 'SET_NAME',
  SET_CPF: 'SET_CPF',
  SET_BIRTHDATE: 'SET_BIRTHDATE',
  SET_KEY_SIGNER: 'SET_KEY_SIGNER',
}

const mutations = {
  [MUTATIONS_TYPES.SET_UUID_DOCUMENT](state, uuidDocument) {
    state.uuidDocument = uuidDocument
  },
  [MUTATIONS_TYPES.SET_EMAIL](state, email) {
    state.email = email
  },
  [MUTATIONS_TYPES.SET_NAME](state, name) {
    state.name = name
  },
  [MUTATIONS_TYPES.SET_CPF](state, cpf) {
    state.cpf = cpf
  },
  [MUTATIONS_TYPES.SET_BIRTHDATE](state, birthdate) {
    state.birthdate = birthdate
  },
  [MUTATIONS_TYPES.SET_KEY_SIGNER](state, keySigner) {
    state.keySigner = keySigner
  }
}

export const GET_UUID_DOCUMENT = "GET_UUID_DOCUMENT"
export const GET_EMAIL = "GET_EMAIL"
export const GET_NAME = "GET_NAME"
export const GET_CPF = "GET_CPF"
export const GET_BIRTHDATE = "GET_BIRTHDATE"
export const GET_KEY_SIGNER = "GET_KEY_SIGNER"

const getters = {
  [GET_UUID_DOCUMENT](state) {
    return state.uuidDocument
  },
  [GET_EMAIL](state) {
    return state.email
  },
  [GET_NAME](state) {
    return state.name
  },
  [GET_CPF](state) {
    return state.cpf
  },
  [GET_BIRTHDATE](state) {
    return state.birthdate
  },
  [GET_KEY_SIGNER](state) {
    return state.keySigner
  },
}

export const SET_UUID_DOCUMENT = 'SET_UUID_DOCUMENT'
export const SET_EMAIL = "SET_EMAIL"
export const SET_NAME = "SET_NAME"
export const SET_CPF = "SET_CPF"
export const SET_BIRTHDATE = "SET_BIRTHDATE"
export const SET_KEY_SIGNER = "SET_KEY_SIGNER"

const actions = {
  [SET_UUID_DOCUMENT]({commit}, uuidDocument) {
    commit(MUTATIONS_TYPES.SET_UUID_DOCUMENT, uuidDocument)
  },
  [SET_EMAIL]({commit}, email) {
    commit(MUTATIONS_TYPES.SET_EMAIL, email)
  },
  [SET_NAME]({commit}, name) {
    commit(MUTATIONS_TYPES.SET_NAME, name)
  },
  [SET_CPF]({commit}, cpf) {
    commit(MUTATIONS_TYPES.SET_CPF, cpf)
  },
  [SET_BIRTHDATE]({commit}, birthdate) {
    commit(MUTATIONS_TYPES.SET_BIRTHDATE, birthdate)
  },
  [SET_KEY_SIGNER]({commit}, keySigner) {
    commit(MUTATIONS_TYPES.SET_KEY_SIGNER, keySigner)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
